import * as defaultsDeep from 'lodash.defaultsdeep';
import { environmentDefaults } from './environment-defaults';

// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.local.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `angular-cli.json`.

const override = {
  baseUrl: 'http://localhost:8080',
  hostname: 'localhost',
  onyxCommonDataUrl: 'http://localhost:8080/ocd/api',
  onyxGPImagesCommonDataUrl: 'https://cdn.dev.onyxcentersource.com/static/custom/gp',
  invoiceHistoryUrl: 'https://ooiv-invoice-history.dev.onyxcentersource.com',

  production: false,

  logServices: {
    consoleLogSubscriber: {
      logLevel: 4
    },
    httpLogSubscriber: {
      logLevel: 0
    }
  },

  googleAnalytics: {
    id: 'UA-96125697-1',
    loadType: 'auto'
  },

  allowApiDocs: true,

  logout: '/login',
  cwr: {
    enable: true
  },

  agencyDashboardUrl: 'https://agency-dashboard.dev.onyxcentersource.com',
  showAgencyDashboard: true

};

export const environment = defaultsDeep(override, environmentDefaults);



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/environments/environment.local.ts